import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Input, } from "@chakra-ui/react";
import { forwardRef } from "react";
/**
 * Sizes and variants the Fluenceur theme adds to Chakra's button and input
 * recipes (`packages/theme/src/recipes/button.recipe.ts`, `input.recipe.ts`).
 *
 * Chakra types a recipe's sizes and variants from a file it generates inside
 * `node_modules` (`chakra typegen`), which a fresh install or CI would not
 * have, and its generated interfaces cannot be widened by declaration merging.
 * So the additions are typed here, in the repository, and these two
 * components carry them through to Chakra's `Button` and `Input` unchanged.
 * Add a size or a variant to the recipe and to the union below together; the
 * portal's theme spec checks that each one named here exists in the recipe.
 */
export const THEME_BUTTON_SIZES = ["cta", "chip"];
export const THEME_BUTTON_VARIANTS = ["secondary"];
export const THEME_INPUT_SIZES = ["creator"];
/** Chakra's `Button`, typed with the theme's own sizes and variants. */
export const ThemedButton = forwardRef(function ThemedButton(props, ref) {
    return _jsx(Button, { ref: ref, ...props });
});
/** Chakra's `Input`, typed with the theme's own sizes. */
export const ThemedInput = forwardRef(function ThemedInput(props, ref) {
    return _jsx(Input, { ref: ref, ...props });
});
